import { api } from 'utility';
import {
  getAssignedDelegationUrl,
  getUsageRestrictionsUrl,
  getDelegationConsumptionUrl,
  getToggleDeligationUrl,
  getDeligationDetaileUrl,
} from 'URLs';
export function getAssignedDelegation(data, params) {
  return api.post(getAssignedDelegationUrl(), data, { params }).then((res) => res.data);
}

export function getAssignedDelegationGroupByHash(params, hash) {
  return api.get(getDeligationDetaileUrl(hash), { params }).then((res) => res.data);
}

export function getUsageRestrictions(data, params) {
  return api.post(getUsageRestrictionsUrl(), data, { params }).then((res) => res.data);
}

export function getDelegationConsumption(data, params) {
  return api.post(getDelegationConsumptionUrl(), data, { params }).then((res) => res.data);
}

export function changeDelegationStatus(id, newStatus) {
  const url = getToggleDeligationUrl(id);
  return newStatus
    ? api.post(url).then((res) => res.data)
    : api.delete(url).then((res) => res.data);
}

export default {
  getAssignedDelegation,
  getAssignedDelegationGroupByHash,
  getUsageRestrictions,
  getDelegationConsumption,
  changeDelegationStatus,
};
